<label class="questionLabel" [attr.for]="question.key">{{question.label}}</label>
@if (masked) {
  <!-- inputFormat (price / km / area / number / licence plate / phone):
       shows "1,250,000", stores the plain value. -->
  <div class="formatted-input" [class.has-unit]="unit">
    <input #formatted class="form-control questionTag input-field-focus" type="text"
           [id]="question.key"
           dir="ltr"
           autocomplete="off"
           [attr.inputmode]="inputMode"
           [attr.aria-label]="question.label"
           [attr.maxlength]="maxDisplayLength"
           [value]="display"
           [disabled]="control?.disabled"
           (input)="onFormattedInput(formatted)"
           (change)="commitFormatted()"/>
    @if (unit) {
      <span class="unit" aria-hidden="true">{{ unit | translate }}</span>
    }
  </div>
} @else {
  <input class="form-control questionTag input-field-focus" [formControl]="control"
         [id]="question.key"
         [type]="nativeType"
         [attr.inputmode]="inputMode"
         [attr.aria-label]="question.label"
         (change)="executeParentFunction($event)"/>
}
